import {
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from "@gearbox-protocol/deploy-tools-ui";
import MultiInput from "components/forms/MultiInput";
import type { FC } from "react";
import type { ControllerRenderProps } from "react-hook-form";

import type { ForkSchema } from "./schema";

interface AnvilFlagsProps {
  field: ControllerRenderProps<ForkSchema, "anvilFlags">;
}

const AnvilFlags: FC<AnvilFlagsProps> = ({ field }) => {
  return (
    <FormItem className="flex flex-row items-center">
      <FormLabel className="w-24">Extra Anvil Flags</FormLabel>
      <FormControl className="ml-2">
        <MultiInput
          field={field}
          className="h-8"
          placeholder="extra anvil flags"
        />
      </FormControl>
      <FormMessage />
    </FormItem>
  );
};

export default AnvilFlags;
